// Petit utilitaire partagé par les contrôleurs de listing (all_perfumes,
// full_bottles, miniatures, category_perfumes, brand_perfumes) pour
// afficher le prix barré + le badge de remise quand une vente flash est
// active sur un parfum — même format API (variants[].promo_price) partout.

import { formatTND } from "./lib/currency"

export { formatTND as formatCurrencyTnd }

const cheapest = (variants) =>
  variants.reduce((best, current) => {
    const currentPrice = parseFloat(current.promo_price ?? current.price)
    const bestPrice = parseFloat(best.promo_price ?? best.price)
    return currentPrice < bestPrice ? current : best
  })

// Variante mise en avant sur une carte de listing. Une taille en vente
// flash passe devant, même si une autre taille reste moins chère : au
// simple "prix le plus bas", une promo sur le 20ml restait invisible tant
// que le 10ml plein tarif était en dessous — la carte n'affichait alors ni
// badge ni prix barré. À défaut de promo, on retombe sur le prix le plus
// bas. Détermine aussi la taille affichée et celle ajoutée au panier.
export function bestVariant(parfum) {
  const variants = parfum.variants || []
  if (variants.length === 0) return null

  const discounted = variants.filter((v) => v.promo_price != null)
  return cheapest(discounted.length > 0 ? discounted : variants)
}

// Bloc de prix HTML (prix barré + prix promo + badge) à insérer dans une
// carte produit. Retombe sur un simple prix si aucune vente flash active.
export function priceBlockHtml(parfum, { priceClass = "perfume-price" } = {}) {
  const variant = bestVariant(parfum)
  if (!variant) return `<p class="${priceClass}">—</p>`

  if (variant.promo_price == null) {
    return `<p class="${priceClass}">${formatTND(variant.price)}</p>`
  }

  const badge = variant.discount_percent
    ? `-${Math.round(variant.discount_percent)}%`
    : "PROMO"

  return `
    <div class="${priceClass} flash-price-block">
      <span class="flash-price-badge">${badge}</span>
      <span class="flash-price-old">${formatTND(variant.price)}</span>
      <span class="flash-price-now">${formatTND(variant.promo_price)}</span>
    </div>
  `
}
